import { yesNoList } from '@/constants';
export const baseFromColumns = (ctx) => {
  console.log(ctx, '1111', ctx.fromData.customerNo);
  return [
    {
      prop: 'projectInitiationCreateDate',
      name: '制单日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
    },
    {
      //立项编号
      prop: 'projectInitiationNo',
      name: '立项编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
      // isHidden: ctx.isCreate,
    },
    {
      prop: 'businessType', // TODO:
      name: '业务类型',
      type: 'select',
      options: ctx.dictListMap?.GoodsTradeProject_businessType || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      maxlength: 80,
    },
    {
      prop: 'projectAddress', // TODO:
      name: '项目地点',
      type: 'input',
    },
    {
      prop: 'subjectMatter', // TODO:
      name: '标的物',
      type: 'dict',
      dictType: 'PROJECT_INITIATION_SUBJECT_MATTER',
      changeMethod: 'changeMethod',
    },

    {
      prop: 'platformtCompanyName',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      // isMultiple: true,
      searchType: 'partner',
      getSearchCode: 'partnerCode',
      extraData: {
        adminFlag: ctx.userInfo.adminFlag,
        companyCode: ctx.userInfo?.companyCode,
        departmentCode: ctx.userInfo?.departmentCode,
        partnerTypes: 'HZHB02,HZHB03', // 客户、供应商、合作伙伴
      },
      currentValue: ctx.fromData.supplierName ? ctx.fromData.supplierName.join(',') : null,
      checkRowKeys: ctx.fromData.supplierNo,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerNo',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB03,HZHB01',
        departmentCode: ctx.userInfo.departmentCode,
        companyCode: ctx.userInfo.companyCode,
      },
      currentValue: ctx.fromData.customerName ? ctx.fromData.customerName.join(',') : null,
      checkRowKeys: ctx.fromData.customerNo,
      // isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'chargePersonNo',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.fromData.chargePersonName ? ctx.fromData.chargePersonName : null,
      checkRowKeys: [ctx.fromData.chargePersonNo ? ctx.fromData.chargePersonNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'declareDate', // TODO
      name: '申报日期',
      type: 'date',
      disabled: true,
    },
    {
      prop: 'projectUsageQuotaWan',
      name: '使用额度',
      type: 'inputNumber',
      append: '万元',
    },
    {
      prop: 'projectAccountingPeriod',
      name: '项目账期',
      type: 'inputNumber',
      append: '天',
    },
    {
      prop: 'projectReceivableQuotaWan',
      name: '应收账款额度',
      type: 'inputNumber',
      append: '万元',
    },
    // {
    //   prop: 'expenseBudget', // TODO
    //   name: '费用预算',
    //   type: 'inputNumber',
    //   append: '万元',
    // },
    // {
    //   prop: 'projectIncomePoint',
    //   name: '项目收益点位',
    //   type: 'inputNumber',
    //   append: '%/月',
    // },
    {
      prop: 'operatingRevenueTarget',
      name: '营业收入目标',
      type: 'inputNumber',
      changeMethod: 'changeMethod',
      append: '万元',
    },
    {
      prop: 'profitTarget', // TODO
      name: '利润目标',
      type: 'inputNumber',
      changeMethod: 'changeMethod',
      append: '万元',
    },
    {
      prop: 'projectNetProfitRate', // TODO
      name: '项目净利润率',
      type: 'inputNumber',
      disabled: true,
      append: '%',
    },
    {
      prop: 'grossProfitRate', // TODO
      name: '毛利率',
      type: 'inputNumber',
      append: '%',
    },
    {
      prop: 'deliveryQuantity',
      name: '发货数量',
      type: 'input',
      // append: '吨',
    },
    // {
    //   prop: 'advanceAmount', // TODO
    //   name: '垫付金额',
    //   type: 'inputNumber',
    //   append: '万元',
    // },
    // {
    //   prop: 'stampDuty', // TODO
    //   name: '印花税',
    //   type: 'inputNumber',
    // },
    // {
    //   prop: 'travelExpense', // TODO
    //   name: '差旅费',
    //   type: 'inputNumber',
    // },

    // {
    //   prop: 'taxRate',
    //   name: '增值税',
    //   type: 'inputNumber',
    // },
    {
      prop: 'costPrediction', // TODO
      name: '营业成本',
      type: 'inputNumber',
      append: '万元',
    },
    {
      prop: 'costOfFunds', // TODO
      name: '资金成本',
      type: 'inputNumber',
      append: '万元',
    },
    {
      prop: 'taxCost', // TODO
      name: '税费成本',
      type: 'inputNumber',
      append: '万元',
    },
    {
      prop: 'sellingExpenses', // TODO
      name: '销售费用',
      type: 'inputNumber',
      append: '万元',
    },
    {
      prop: 'projectMonthlyReturnRate', // TODO
      name: '项目月收益率',
      type: 'inputNumber',
      append: '%',
    },
    {
      prop: 'effectiveDateOfYield', // TODO
      name: '收益率生效日期',
      type: 'date',
    },
    {
      prop: 'upstreamSettlementAdjustment', // TODO
      name: '上游结算调整',
      type: 'inputNumber',
    },
    {
      prop: 'upstreamSettlementAdjustmentValue', // TODO
      name: '上游结算调整值',
      type: 'inputNumber',
    },
    {
      prop: 'serviceChainRestriction', // TODO
      name: '业务链限制',
      type: 'select',
      options: yesNoList,
    },
    {
      prop: 'paymentMethod', // TODO
      name: '回款方式',
      type: 'select',
      options: ctx.dictListMap?.GoodsTradeProject_paymentMethod || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'priceDifferAdjust', // TODO
      name: '价差调整',
      type: 'inputNumber',
      append: '天',
    },
    {
      prop: 'approveDate',
      name: '立项通过时间',
      disabled: true,
      type: 'input',
    },
    {
      prop: 'dateRate',
      name: '资金成本日利率',
      type: 'inputNumber',
      append: '%',
    },
    {
      prop: 'validDate',
      name: '授信有效期始',
      type: 'date',
      format: 'yyyy-MM-dd',
    },
    {
      prop: 'invalidDate',
      name: '授信有效期止',
      type: 'date',
      format: 'yyyy-MM-dd',
    },
    {
      //备注
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 200,
    },
  ];
};

export const formRules = () => {
  return {
    businessType: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectName: [
      {
        required: true,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    indication: [
      {
        required: true,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    subjectMatter: [
      {
        required: true,
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    platformtCompanyName: [
      {
        required: true,
        message: '必填字段',
        trigger: ['change', 'blur'],
      },
    ],
    // supplierNo: [
    //   {
    //     required: ctx.fromData.businessType != 'PIBT01' && ctx.fromData.businessType != 'PIBT04',
    //     message: '必填字段',
    //     trigger: 'change',
    //   },
    // ],
    // customerNo: [
    //   {
    //     required: ctx.fromData.businessType != 'PIBT01',
    //     message: '必填字段',
    //     trigger: 'change',
    //   },
    // ],
    chargePersonName: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    declareDate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectUsageQuotaWan: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectAccountingPeriod: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectReceivableQuotaWan: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    expenseBudget: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectIncomePoint: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    operatingRevenueTarget: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    profitTarget: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectNetProfitRate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    grossProfitRate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    deliveryQuantity: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectMonthlyReturnRate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    serviceChainRestriction: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    paymentCollectionMethod: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    applyDepartmentNo: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    dateRate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    validDate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    invalidDate: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
  };
};
